import React from "react";
import { Typography } from "@material-ui/core";
import { RBModal } from "../../../components/RBModal";
import { RBPdf } from "../../../components/RBPdf";
import { Colors, Spacing } from "../../../theme/Theme";
import { isImageDocument } from "../utils/rbPaySettings.formatters";

interface RBPayDocumentPreviewModalProps {
  open: boolean;
  previewUrl: string;
  fileType: string;
  fileName: string;
  onClose: () => void;
}

export const RBPayDocumentPreviewModal: React.FC<RBPayDocumentPreviewModalProps> = ({
  open,
  previewUrl,
  fileType,
  fileName,
  onClose,
}) => {
  return (
    <RBModal open={open} onClose={onClose} modalTitle="Document Preview" modalWidth={760}>
      <div
        style={{
          padding: Spacing.large,
          backgroundColor: Colors.defaultGrey,
          minHeight: 500,
        }}
      >
        <div
          style={{
            backgroundColor: Colors.white,
            borderRadius: 10,
            minHeight: 460,
            // Bound the height and scroll so multi-page PDFs are reachable.
            maxHeight: "72vh",
            overflowY: "auto",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            padding: Spacing.large,
          }}
        >
          {previewUrl ? (
            isImageDocument(fileType) ? (
              <img
                src={previewUrl}
                alt={fileName || "Uploaded document"}
                style={{ maxWidth: "100%", maxHeight: 420, objectFit: "contain" }}
              />
            ) : fileType === "application/pdf" ? (
              <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <RBPdf fileUrl={previewUrl} fitWidth />
              </div>
            ) : (
              <Typography>File format not supported for preview.</Typography>
            )
          ) : (
            <Typography>No document selected.</Typography>
          )}
        </div>
      </div>
    </RBModal>
  );
};
